import { AxiosError } from 'axios'

import {
  IApiAppointment,
  IAppointmentInfoResponse,
  IAppointmentReasonCancellation,
  IAppointmentStatus,
  IConfirmAppointmentProps,
  INextAppointmentResponse,
  IPastAppointmentResponse
} from '../../dtos/Appointments'

import AppointmentsDataSource from '../dataSource/AppointmentsDataSource'
import { http } from '../Http'

export default class AppointmentsMapper implements AppointmentsDataSource {
  async reasonCancellationAppointment(): Promise<
    IApiAppointment<string | IAppointmentReasonCancellation>
  > {
    try {
      const { data } = await http.get<
        IApiAppointment<IAppointmentReasonCancellation>
      >(`send_data/reason_cancellation_appointment`)
      return data
    } catch (error: unknown) {
      return {
        statusCode: (error as AxiosError).response?.status as number,
        body: (error as AxiosError).response?.statusText as string,
        headers: {
          'Access-Control-Allow-Headers': '',
          'Access-Control-Allow-Origin': '',
          'Access-Control-Allow-Methods': '',
          'Access-Control-Allow-Credentials': false
        }
      }
    }
  }

  async confirmAppointment({
    appointment_id,
    action,
    reschedule_id,
    reason
  }: IConfirmAppointmentProps): Promise<
    IApiAppointment<IAppointmentStatus | string>
  > {
    try {
      const { data } = await http.post<IApiAppointment<IAppointmentStatus>>(
        `/save_data/appointment_status/${appointment_id}`,
        { action, reschedule_id, reason }
      )
      return data
    } catch (error: unknown) {
      return {
        statusCode: (error as AxiosError).response?.status as number,
        body: (error as AxiosError).response?.statusText as string,
        headers: {
          'Access-Control-Allow-Headers': '',
          'Access-Control-Allow-Origin': '',
          'Access-Control-Allow-Methods': '',
          'Access-Control-Allow-Credentials': false
        }
      }
    }
  }

  async getAppointmentInfo(
    appointmentId: string
  ): Promise<IApiAppointment<IAppointmentInfoResponse | string>> {
    try {
      const { data } = await http.get<
        IApiAppointment<IAppointmentInfoResponse>
      >(`send_data/appointment_info/${appointmentId}`)
      return data
    } catch (error: unknown) {
      return {
        statusCode: (error as AxiosError).response?.status as number,
        body: (error as AxiosError).response?.statusText as string,
        headers: {
          'Access-Control-Allow-Headers': '',
          'Access-Control-Allow-Origin': '',
          'Access-Control-Allow-Methods': '',
          'Access-Control-Allow-Credentials': false
        }
      }
    }
  }

  async nextAppointments(
    userId: string
  ): Promise<IApiAppointment<INextAppointmentResponse | string>> {
    try {
      const { data } = await http.get<
        IApiAppointment<INextAppointmentResponse>
      >(`/send_data/next_patient_appointments/${userId}`)
      return data
    } catch (error: unknown) {
      return {
        statusCode: (error as AxiosError).response?.status as number,
        body: (error as AxiosError).response?.statusText as string,
        headers: {
          'Access-Control-Allow-Headers': '',
          'Access-Control-Allow-Origin': '',
          'Access-Control-Allow-Methods': '',
          'Access-Control-Allow-Credentials': false
        }
      }
    }
  }

  async pastAppointments(
    userId: string
  ): Promise<IApiAppointment<IPastAppointmentResponse | string>> {
    try {
      const { data } = await http.get<
        IApiAppointment<IPastAppointmentResponse>
      >(`/send_data/past_patient_appointments/${userId}`)
      return data
    } catch (error: unknown) {
      return {
        statusCode: (error as AxiosError).response?.status as number,
        body: (error as AxiosError).response?.statusText as string,
        headers: {
          'Access-Control-Allow-Headers': '',
          'Access-Control-Allow-Origin': '',
          'Access-Control-Allow-Methods': '',
          'Access-Control-Allow-Credentials': false
        }
      }
    }
  }
}
